import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const STORE_SLUG = "gray-volleyball";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gv_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Customer (Google) auth — separate instance so it never carries the admin token
export const customerApi = axios.create({ baseURL: API, withCredentials: true });
customerApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("gv_customer_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const BACK_OPTION_LABELS = {
  front_only: "Front Design Only",
  team_back: "Front + Team/Roster Back",
  name_number: "Front + Player Name & Number",
};
